import dhtmlXCellTop from '../dhtmlXLayoutObject/dhtmlXCellTop';
import dhtmlXTabBarCell from './dhtmlXTabBarCell';
import {dhx4} from '../../global/dhx4OrDhx';
import dhtmlx from '../../global/dhtmlx';


class dhtmlXTabBar extends dhtmlXCellTop {
    constructor(g, m) {
        super();
        var h = this;
        this.conf = {
            skin:
                dhx4.skin ||
                (typeof dhtmlx != "undefined" ? dhtmlx.skin : null) ||
                dhx4.skinDetect("dhxtabbar") ||
                "material",
            css: "dhxtabbar",
            lastActive: null,
            closeButton: false,
            align: "left",
            tabsMode: m == "bottom" ? "bottom" : "top",
            tabsContCss: "",
            contZone: true,
            transSpeed: "0.15s",
            arwMode: "always",
            tabsOfs: 1,
            tabsTop: 0,
            url_demand: false,
            urls: {},
            autoload: {},
            tabsWidth: {
                dhx_terrace: [44, 14],
                dhx_web: [35, 9],
                dhx_skyblue: [35, 9],
                material: [44, 14]
            }
        };
        if (this.conf.skin == "material") {
            this.conf.arwMode = "auto";
        }
        var c = navigator.userAgent;
        if (
            c.indexOf("Safari") >= 0 &&
            (c.indexOf("5.1.7") >= 0 ||
                (c.match(/7[\.\d]* mobile/gi) != null &&
                    c.match(/AppleWebKit/gi) != null))
        ) {
            this.conf.tabsContCss = " safari_517_fix";
        }
        var l;
        if (g != null && typeof g == "object" && typeof g.tagName == "undefined") {
            l = g.parent;
            if (typeof g.skin != "undefined") {
                this.conf.skin = g.skin;
            }
            if (typeof g.mode != "undefined") {
                this.conf.tabsMode = g.mode == "bottom" ? "bottom" : "top";
            }
            if (typeof g.align != "undefined") {
                this.conf.align = g.align == "right" ? "right" : "left";
            }
            if (typeof g.close_button != "undefined") {
                this.conf.closeButton = dhx4.s2b(g.close_button);
            }
            if (typeof g.content_zone != "undefined") {
                this.conf.contZone = dhx4.s2b(g.content_zone);
            }
            if (typeof g.xml != "undefined") {
                this.conf.autoload.xml = g.xml;
            }
            if (typeof g.json != "undefined") {
                this.conf.autoload.xml = g.json;
            }
            if (typeof g.tabs != "undefined") {
                this.conf.autoload.tabs = g.tabs;
            }
            if (typeof g.onload != "undefined") {
                this.conf.autoload.onload = g.onload;
            }
            if (typeof g.arrows_mode != "undefined") {
                this.conf.autoload.arrows_mode = g.arrows_mode;
            }
        } else {
            l = g;
        }
        dhtmlXCellTop.apply(this, [l, g.offsets]);
        if (this.base._ofs != null && this.base._ofs.t != null) {
            this.conf.tabsTop = this.base._ofs.t;
        }
        this.tabsMode = document.createElement("DIV");
        this.tabsMode.className = "dhxtabbar_tabs_" + this.conf.tabsMode;
        this.cont.appendChild(this.tabsMode);
        this.tabsArea = document.createElement("DIV");
        this.tabsArea.className =
            "dhxtabbar_tabs dhxtabbar_tabs_" + this.conf.tabsMode;
        this.tabsArea.innerHTML =
            "<div class='dhxtabbar_tabs_ar_left'>" +
            "<div class='dhxtabbar_arrow_img goingicon go-left'></div></div><div class='dhxtabbar_tabs_base'><div class='dhxtabbar_tabs_cont_" +
            this.conf.align +
            this.conf.tabsContCss +
            "'><div class='dhxtabbar_tabs_line'></div></div></div><div class='dhxtabbar_tabs_ar_right'>" +
            "<div class='dhxtabbar_arrow_img  goingicon go-right'></div></div>";
        this.tabsArea.style.top =
            this.conf.tabsMode == "top" ? this.conf.tabsTop + "px" : "auto";
        this.tabsMode.appendChild(this.tabsArea);
        this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align] = "0px";
        this.tabsArea.childNodes[0].onclick = function () {
            if (h.conf.align == "left") {
                // @ts-ignore
                h._moveTabs(1);
            } else {
                // @ts-ignore
                h._moveTabs(-1);
            }
        };
        this.tabsArea.childNodes[2].onclick = function () {
            if (h.conf.align == "left") {
                // @ts-ignore
                h._moveTabs(-1);
            } else {
                // @ts-ignore
                h._moveTabs(1);
            }
        };
        this._onTabsAreaClick = function (a) {
            return this._callMainEvent("onTabClose", [a]);
        };
        this.tabsArea.onclick = function (n) {
            n = n || event;
            var a = n.target || n.srcElement;
            while (a != null) {
                if (typeof a._tabCloseId != "undefined") {
                    // @ts-ignore
                    if (h._onTabsAreaClick(a._tabCloseId) !== true) {
                        return;
                    }
                    h.t[a._tabCloseId].conf.remove = true;
                    h._hideTab(a._tabCloseId);
                    a = null;
                } else {
                    if (typeof a._tabId != "undefined") {
                        h._doOnClick(a._tabId);
                        a = null;
                    }
                }
                if (a != null) {
                    a = a.parentNode;
                    if (a == this) {
                        a = null;
                    }
                }
            }
        };
        this.tabsArea.onselectstart = function (a) {
            a = a || event;
            if (a.preventDefault) {
                a.preventDefault();
            } else {
                a.returnValue = false;
            }
        };
        this._doOnClick = function (a) {
            this.callEvent("onTabClick", [a, this.conf.lastActive]);
            if (this.t[a].conf.enabled) {
                this._setTabActive(a);
            }
        };
        this.t = {};
        this.addTab = function (a, w, o, u, s, x) {
            x =
                typeof x == "undefined"
                    ? this.conf.closeButton == true
                    : dhx4.s2b(x);
            s = dhx4.s2b(s);
            var r = document.createElement("DIV");
            r.className = "dhxtabbar_tab";
            r.innerHTML =
                "<div class='dhxtabbar_tab_text" +
                (x ? " dhxtabbar_tab_text_close" : "") +
                "'>" +
                w +
                "</div>" +
                (x ? "<div style='color:#666;font-size: 13px;top:1px;' class='dhxtabbar_tab_close goingicon go-close'></div>" : "");
            r._tabId = a;
            if (x) {
                r.childNodes[1]._tabCloseId = a;
            }
            var n = this.tabsArea.childNodes[1].firstChild;
            if (u != null && u + 1 > 0 && u + 1 < n.childNodes.length) {
                n.insertBefore(r, n.childNodes[u + 1]);
            } else {
                n.appendChild(r);
            }
            var y = false;
            if (typeof o == "undefined" || o == null || o == "*") {
                o = this._getLabelWidth(w, x);
                y = true;
            } else {
                o = parseInt(o);
            }
            r.style.width = o + "px";
            var v = new dhtmlXTabBarCell(a, this);
            this.tabsMode.appendChild(v.cell);
            this.t[a] = {
                tab: r,
                cell: v,
                conf: {
                    text: w,
                    visible: true,
                    active: false,
                    enabled: true,
                    close: x,
                    width: o,
                    autowidth: y
                }
            };
            n = v = null;
            if (s) {
                this._setTabActive(a);
            } else {
                this._adjustCell(a);
            }
            if (this.conf.initSeq != true && this.conf.arwMode == "auto") {
                this.setSizes();
            }
        };
        this.setSizes = function () {
            this._adjustCont();
            if (this.conf.tabsAreaOfs == null) {
                this.tabsArea.style.width = this.cont.offsetWidth + "px";
                this.conf.tabsAreaOfs =
                    parseInt(this.tabsArea.style.width) - this.tabsArea.offsetWidth;
            }
            this.tabsArea.style.width =
                this.cont.offsetWidth + this.conf.tabsAreaOfs + "px";
            this._adjustCell(this.conf.lastActive);
            this._adjustTabs(true);
            this.callEvent("_onSetSizes", []);
        };
        this._adjustCell = function (r) {
            if (!this.conf.contZone || r == null) {
                return;
            }
            var o =
                (this.conf.tabsMode == "top" ? this.tabsArea.offsetHeight : 0) +
                this.conf.tabsTop;
            var n =
                this.cont.offsetHeight - this.tabsArea.offsetHeight - this.conf.tabsTop;
            var a = this.t[r].cell.dataType;
            if (
                this.conf.skin == "dhx_skyblue" &&
                (a == "layout" || a == "tabbar" || a == "acc")
            ) {
                if (this.conf.tabsMode == "top") {
                    o = o - 1;
                }
                n = n + 1;
            }
            if (r != this.conf.lastActive) {
                o = -5000;
                this.t[r].cell.cell.style.visibility = "hidden";
                this.t[r].cell.cell.style.zIndex = 0;
            }
            this.t[r].cell._setSize(0, o, this.cont.offsetWidth, n);
        };
        this.setTabsMode = function (a) {
            this.conf.tabsMode = a == "bottom" ? "bottom" : "top";
            this.tabsMode.className = "dhxtabbar_tabs_" + this.conf.tabsMode;
            this.tabsArea.className =
                "dhxtabbar_tabs dhxtabbar_tabs_" + this.conf.tabsMode;
            this.tabsArea.style.top =
                this.conf.tabsMode == "top" ? this.conf.tabsTop + "px" : "auto";
            this.setSizes();
        };
        this._tabCss = function (u) {
            var n = this.t[u].conf.active;
            var s = !this.t[u].conf.enabled;
            var o = !this.t[u].conf.visible;
            return (
                "dhxtabbar_tab" +
                (o
                    ? " dhxtabbar_tab_hidden"
                    : n || s
                        ? " dhxtabbar_tab" + (n ? "_actv" : "") + (s ? "_dis" : "")
                        : "")
            );
        };
        this._getLabelWidth = function (o, n) {
            if (this.tabsTextTest == null) {
                this.tabsTextTest = document.createElement("SPAN");
                this.tabsTextTest.className =
                    "dhxtabbar_tabs_text_test_" + this.conf.skin;
            }
            document.body.appendChild(this.tabsTextTest);
            this.tabsTextTest.innerHTML = o;
            var a = this.tabsTextTest.offsetWidth;
            if (dhx4.isIE && a == 0) {
                a = this.tabsTextTest.offsetWidth;
            }
            a += this.conf.tabsWidth[this.conf.skin][0];
            if (n == true) {
                a += this.conf.tabsWidth[this.conf.skin][1];
            }
            document.body.removeChild(this.tabsTextTest);
            return a;
        };
        this._adjustTabs = function (r) {
            if (this._checkArrows() == true || r == true) {
                this.tabsArea.childNodes[1].style.left =
                    this.tabsArea.childNodes[0].offsetWidth - 1 + "px";
                this.tabsArea.childNodes[1].style.width =
                    Math.max(
                        0,
                        this.tabsArea.clientWidth -
                        this.tabsArea.childNodes[0].offsetWidth -
                        this.tabsArea.childNodes[2].offsetWidth
                    ) +
                    this.conf.tabsOfs * 2 +
                    "px";
            }
            var u = this.tabsArea.childNodes[1];
            if (u.offsetWidth < 5) {
                u = null;
                return;
            }
            var a = parseInt(u.childNodes[0].style[this.conf.align]);
            var o = null;
            for (var s = 0; s < u.childNodes[0].childNodes.length; s++) {
                var v = u.childNodes[0].childNodes[s]._tabId;
                if (v != null && this.t[v].conf.visible) {
                    var n = this.t[v].tab.offsetWidth - this.conf.tabsOfs;
                    if (this.t[v].conf.active) {
                        if (a < 0 || u.offsetWidth < n) {
                            o = {d: 1, id: v};
                        } else {
                            if (a + n > u.offsetWidth) {
                                o = {d: -1, id: v};
                            }
                        }
                    }
                    a += n;
                }
            }
            if (o != null) {
                this._moveTabs(o.d, o.id);
            } else {
                if (u.offsetWidth > a + 1) {
                    u.childNodes[0].style[this.conf.align] =
                        Math.min(
                            0,
                            parseInt(u.childNodes[0].style[this.conf.align]) +
                            (u.offsetWidth - a)
                        ) + "px";
                }
            }
            u = o = null;
        };
        this._moveTabs = function (y, r) {
            var o = this.tabsArea.childNodes[1].childNodes[0];
            var v = 0;
            var A = [];
            var D = null;
            for (var a = 0; a < o.childNodes.length; a++) {
                var n = o.childNodes[a]._tabId;
                if (n != null && this.t[n].conf.visible) {
                    A.push({
                        id: n,
                        w: this.t[n].tab.offsetWidth - this.conf.tabsOfs,
                        ind: v
                    });
                    if (n == r) {
                        D = v;
                    }
                    v++;
                }
            }
            var C = parseInt(
                this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align]
            );
            var u =
                this.tabsArea.clientWidth -
                this.tabsArea.childNodes[0].offsetWidth -
                this.tabsArea.childNodes[2].offsetWidth +
                this.conf.tabsOfs;
            var w = null;
            var s = null;
            for (let a = 0; a < A.length; a++) {
                A[a].x = C;
                if (w == null && C >= 0 && C + A[a].w > 0) {
                    w = A[a];
                }
                if (C < u && C + A[a].w <= u) {
                    s = A[a];
                }
                C += A[a].w;
            }
            var E = null;
            if (D != null) {
                E = A[D];
            } else {
                E = null;
                if (y > 0) {
                    if (w == null) {
                        if (A.length > 0) {
                            E = A[A.length - 1];
                        }
                    } else {
                        if (w.ind > 0 && A.length >= w.ind) {
                            E = A[w.ind - 1];
                        }
                    }
                } else {
                    if (s == null) {
                        if (A.length > 0) {
                            E = A[0];
                        }
                    } else {
                        if (A.length > s.ind) {
                            E = A[s.ind + 1];
                        }
                    }
                }
            }
            if (E != null) {
                if (y > 0) {
                    if (C < u) {
                        o.style[this.conf.align] =
                            Math.min(0, parseInt(o.style[this.conf.align]) + (u - C)) + "px";
                    } else {
                        o.style[this.conf.align] =
                            parseInt(o.style[this.conf.align]) - E.x + "px";
                    }
                } else {
                    o.style[this.conf.align] =
                        parseInt(o.style[this.conf.align]) - E.x + u - E.w + "px";
                }
            }
            o = E = A = null;
        };
        this._getNextVisible = function (n, a) {
            return this._getNearVisible(n, a, "next");
        };
        this._getPrevVisible = function (n, a) {
            return this._getNearVisible(n, a, "previous");
        };
        this._getFirstVisible = function () {
            return this._getNearVisible(null, false, "first");
        };
        this._getNearVisible = function (u, o, s) {
            var r = null;
            if (s == "first") {
                r = this.tabsArea.childNodes[1].childNodes[0].childNodes[1];
                s = "next";
            } else {
                if (u == null || this.t[u] == null) {
                    return o ? this._getFirstVisible() : null;
                }
                r = this.t[u].tab[s + "Sibling"];
            }
            var n = null;
            while (r != null && n == null) {
                var a = r._tabId;
                if (a != null && n == null && this.t[a].conf.visible) {
                    n = a;
                } else {
                    r = r[s + "Sibling"];
                }
            }
            r = null;
            return n;
        };
        this._showTab = function (n, a) {
            if (this.t[n] == null) {
                return;
            }
            if (this.t[n].conf.transActv == true) {
                if (this.t[n].conf.transMode == "show") {
                    return;
                }
            } else {
                if (this.t[n].conf.visible == true) {
                    return;
                }
            }
            if (this.conf.transProp !== false) {
                this.t[n].conf.transActv = true;
                this.t[n].conf.transMode = "show";
                this.t[n].conf.transProp = this.conf.transProp;
                this.t[n].conf.transActvId = a ? n : null;
                if (!this.t[n].conf.transEv) {
                    this.t[n].tab.addEventListener(
                        this.conf.transEv,
                        this._doOnTrEnd,
                        false
                    );
                    this.t[n].conf.transEv = true;
                }
                this.t[n].conf.visible = true;
                this.t[n].tab.className = this._tabCss(n);
                this.t[n].tab.style[this.conf.transProp] = this.conf.transValueWidth;
                this.t[n].tab.style.width = this.t[n].conf.width + "px";
                if (this.t[n].tab.clientWidth >= this.t[n].conf.width) {
                    this.t[n].tab.style.visibility = "visible";
                }
            } else {
                this.t[n].conf.visible = true;
                this.t[n].tab.style.display = "";
                if (a || this.t[n].conf.active) {
                    this.t[n].conf.active = false;
                    this._setTabActive(n);
                } else {
                    this._adjustTabs();
                }
            }
        };
        this._hideTab = function (u, a) {
            if (this.t[u] == null) {
                return;
            }
            if (this.t[u].conf.transActv == true) {
                if (this.t[u].conf.transMode == "hide") {
                    return;
                }
            } else {
                if (this.t[u].conf.visible != true) {
                    return;
                }
            }
            var n = false;
            if (this.conf.lastActive == u) {
                this.conf.lastActive = null;
                this.t[u].conf.active = false;
                this.t[u].tab.className = this._tabCss(u);
                n = true;
            }
            var r = this._getPrevVisible(u);
            var o = this._getNextVisible(u);
            var s = n == true && a !== false ? (a == true ? null : a) || o || r : null;
            if (this.conf.transProp !== false) {
                this.t[u].conf.transActv = true;
                this.t[u].conf.transMode = "hide";
                this.t[u].conf.transProp = this.conf.transProp;
                this.t[u].conf.transActvId = s;
                this.t[u].conf.visible = false;
                if (!this.t[u].conf.transEv) {
                    this.t[u].tab.addEventListener(
                        this.conf.transEv,
                        this._doOnTrEnd,
                        false
                    );
                    this.t[u].conf.transEv = true;
                }
                this.t[u].tab.style.visibility = "hidden";
                this.t[u].tab.className = h._tabCss(u);
                this.t[u].tab.style[this.conf.transProp] = this.conf.transValueWidth;
                this.t[u].tab.style.width = "0px";
            } else {
                this.t[u].tab.style.display = "none";
                this.t[u].conf.visible = false;
                if (this.conf.contZone) {
                    this.t[u].cell.cell.style.visibility = "hidden";
                    this.t[u].cell.cell.style.top = "-5000px";
                }
                if (s != null) {
                    this._setTabActive(s);
                }
                this._adjustTabs();
                if (this.t[u].conf.remove) {
                    this._removeTab(u);
                }
            }
        };
        this._isTabVisible = function (a) {
            return this.t[a].conf.visible == true;
        };
        this._doOnTrEnd = function () {
            var o = this._tabId;
            if (h.t[o] == null) {
                return;
            }
            var a = h.t[o];
            var n = a.conf.transActvId;
            if (a.conf.transMode == "hide") {
                if (a.conf.remove) {
                    h._removeTab(o);
                } else {
                    a.tab.style[a.conf.transProp] = "";
                    if (h.conf.contZone) {
                        a.cell.cell.style.visibility = "hidden";
                        a.cell.cell.style.top = "-5000px";
                    }
                    a.conf.transActv = false;
                }
            } else {
                if (a.conf.transMode == "show") {
                    a.tab.style[a.conf.transProp] = "";
                    a.tab.style.visibility = "visible";
                    a.conf.transMode = null;
                    a.conf.transActv = false;
                }
            }
            if (n != null) {
                h._setTabActive(n);
            } else {
                h._adjustTabs();
            }
            a = null;
        };
        this.enableTabCloseButton = function (a) {
            this.conf.closeButton = dhx4.s2b(a);
        };
        this.unload = function () {
            this.conf.unloading = true;
            this.clearAll();
            this.t = null;
            if (this.tabsTextTest != null) {
                if (this.tabsTextTest.parentNode) {
                    this.tabsTextTest.parentNode.removeChild(this.tabsTextTest);
                }
                this.tabsTextTest = null;
            }
            dhx4._enableDataLoading(this, null, null, null, "clear");
            this.tabsArea.childNodes[0].onclick = null;
            this.tabsArea.childNodes[2].onclick = null;
            this.tabsArea.onclick = null;
            this.tabsArea.onselectstart = null;
            this.tabsArea.parentNode.removeChild(this.tabsArea);
            this.tabsArea = null;
            this.tabsMode.parentNode.removeChild(this.tabsMode);
            this.tabsMode = null;
            this._unloadTop();
            dhx4._eventable(this, "clear");
            for (var n in this) {
                this[n] = null;
            }
            h = null;
        };
        this.enableContentZone = function (a) {
            this.conf.contZone = a == true;
        };
        this.setSkin = function (o) {
            this._setBaseSkin(o);
            this.conf.skin = o;
            if (this.tabsTextTest != null) {
                this.tabsTextTest.className =
                    "dhxtabbar_tabs_text_test_" + this.conf.skin;
            }
            for (var n in this.t) {
                this.t[n].cell._resetSizeState();
                if (this.t[n].conf.autowidth == true) {
                    this.t[n].conf.width = this._getLabelWidth(
                        this.t[n].conf.text,
                        this.t[n].conf.close
                    );
                    if (this.t[n].conf.visible) {
                        this.t[n].tab.style.width = this.t[n].conf.width + "px";
                    }
                }
            }
            this.conf.tabsAreaOfs = null;
            this._fixTabsOfs();
            this.setSizes();
        };
        this.setAlign = function (a) {
            a = a == "left" ? "left" : "right";
            if (a == this.conf.align) {
                this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align] = "0px";
                return;
            }
            if (this.conf.transProp !== false) {
                this.tabsArea.childNodes[1].childNodes[0].style[this.conf.transProp] = "";
            }
            this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align] = "";
            this.conf.align = a;
            this.tabsArea.childNodes[1].childNodes[0].className =
                "dhxtabbar_tabs_cont_" + this.conf.align + this.conf.tabsContCss;
            this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align] = "0px";
            if (this.conf.transProp !== false) {
                this.conf.transValuePos = this.conf.align + " " + this.conf.transSpeed;
                this.tabsArea.childNodes[1].childNodes[0].style[
                    this.conf.transProp
                    ] = this.conf.transValuePos;
            }
        };
        this._initObj = function (r) {
            this.conf.initSeq = true;
            this.clearAll();
            var a = false;
            if (r.settings != null) {
                if (r.settings.skin != null) {
                    this.setSkin(r.settings.skin);
                }
                if (r.settings.close_button != null) {
                    this.enableTabCloseButton(dhx4.s2b(r.settings.close_button));
                } else {
                    if (r.settings.closeButton != null) {
                        this.enableTabCloseButton(dhx4.s2b(r.settings.closeButton));
                    }
                }
                if (r.settings.align != null) {
                    this.setAlign(r.settings.align);
                }
                if (r.settings.hrefmode == "ajax") {
                    a = true;
                }
                if (r.settings.hrefmode == "ajax-html") {
                    a = true;
                    this.conf.url_demand = true;
                }
            }
            if (r.tabs != null) {
                for (var o = 0; o < r.tabs.length; o++) {
                    var n = r.tabs[o];
                    if (typeof n.id == "undefined") {
                        n.id = dhx4.newId();
                    }
                    if (!isNaN(parseInt(n.width))) {
                        n.width = parseInt(n.width);
                    } else {
                        n.width = null;
                    }
                    this.addTab(
                        n.id,
                        n.text || n.label || "",
                        n.width,
                        n.index,
                        dhx4.s2b(n.selected) || dhx4.s2b(n.active),
                        n.close
                    );
                    if (n.content != null) {
                        this.cells(n.id).attachHTMLString(n.content);
                    } else {
                        if (n.href != null) {
                            if (this.conf.url_demand == true) {
                                this.conf.urls[n.id] = {href: n.href, ajax: a};
                            } else {
                                this.cells(n.id).attachURL(n.href, a);
                            }
                        }
                    }
                    if (
                        typeof n.enabled != "undefined" &&
                        dhx4.s2b(n.enabled) == false
                    ) {
                        this.tabs(n.id).disable();
                    } else {
                        if (
                            typeof n.disabled != "undefined" &&
                            dhx4.s2b(n.disabled) == true
                        ) {
                            this.tabs(n.id).disable();
                        }
                    }
                }
            }
            this.conf.initSeq = false;
            if (this.conf.arwMode == "auto") {
                this.setSizes();
            }
            if (this.conf.url_demand == true) {
                this._loadURLOnDemand(this.conf.lastActive);
            }
        };
        this._xmlToObj = function (v) {
            var u = {settings: {}, tabs: []};
            var n = v.getElementsByTagName("tabbar")[0];
            if (n != null) {
                for (var x in {skin: 1, align: 1, closeButton: 1, hrefmode: 1}) {
                    if (n.getAttribute(x) != null) {
                        u.settings[x] = n.getAttribute(x);
                    }
                }
                var A = n.getElementsByTagName("tab");
                for (var o = 0; o < A.length; o++) {
                    var s = {text: A[o].firstChild.nodeValue || ""};
                    for (let x in {
                        id: 1,
                        width: 1,
                        close: 1,
                        selected: 1,
                        active: 1,
                        enabled: 1,
                        disabled: 1,
                        href: 1
                    }) {
                        if (A[o].getAttribute(x) != null) {
                            s[x] = A[o].getAttribute(x);
                        }
                    }
                    var C = A[o].getElementsByTagName("content")[0];
                    if (C != null) {
                        s.content = "";
                        for (var y = 0; y < C.childNodes.length; y++) {
                            s.content += C.childNodes[y].nodeValue || "";
                        }
                    }
                    u.tabs.push(s);
                }
            }
            return u;
        };
        dhx4._enableDataLoading(this, "_initObj", "_xmlToObj", "tabbar", {
            struct: true
        });
        var e = dhx4.transDetect();
        this.conf.transProp = e.transProp;
        this.conf.transEv = e.transEv;
        this.conf.transValueWidth = "width " + this.conf.transSpeed;
        e = null;
        if (this.conf.transProp !== false) {
            this.conf.transValuePos = this.conf.align + " " + this.conf.transSpeed;
            this.tabsArea.childNodes[1].childNodes[0].style[
                this.conf.transProp
                ] = this.conf.transValuePos;
        }
        this._callMainEvent = function (n, a) {
            return this.callEvent(n, a);
        };
        dhx4._eventable(this);
        if (this.conf.autoload.json != null) {
            this.loadStruct(this.conf.autoload.json, this.conf.autoload.onload);
        } else {
            if (this.conf.autoload.xml != null) {
                this.loadStruct(this.conf.autoload.xml, this.conf.autoload.onload);
            } else {
                if (this.conf.autoload.tabs != null) {
                    this.loadStruct(
                        {tabs: this.conf.autoload.tabs},
                        this.conf.autoload.onload
                    );
                }
            }
        }
        if (this.conf.autoload.arrows_mode != null) {
            this.setArrowsMode(this.conf.autoload.arrows_mode);
        }
        this._fixTabsOfs();
        this.setSizes();
        return this;
    }
}
dhtmlXTabBar.prototype._fixTabsOfs = function () {
    var jsonObj = {
        dhx_skyblue: 1,
        dhx_web: 0,
        dhx_terrace: 1,
        material: 0
    };
    this.conf.tabsOfs = jsonObj[this.conf.skin];
};
dhtmlXTabBar.prototype.cells = dhtmlXTabBar.prototype.tabs = function (a) {
    if (this.t[a]) {
        return this.t[a].cell;
    }
    return null;
};
dhtmlXTabBar.prototype.getAllTabs = function () {
    var e = [];
    for (var c in this.t) {
        e.push(c);
    }
    return e;
};
dhtmlXTabBar.prototype._setTabActive = function (c, a) {
    if (!this.t[c] || this.t[c].conf.active) {
        return;
    }
    if (typeof a == "undefined") {
        a = true;
    }
    if (a == true &&
        this.callEvent("onSelect", [c, this.conf.lastActive]) !== true) {
        return;
    }
    this.setTabInActive();
    this.t[c].conf.active = true;
    if (this.conf.contZone) {
        this.t[c].cell.cell.style.visibility = "visible";
        this.t[c].cell.cell.style.top = "0px";
        this.t[c].cell.cell.style.zIndex = 1;
    }
    this.t[c].tab.className = this._tabCss(c);
    this.conf.lastActive = c;
    this.setSizes();
    if (this.conf.url_demand == true) {
        this._loadURLOnDemand(c);
    }
};
dhtmlXTabBar.prototype.setTabInActive = function () {
    if (this.conf.lastActive != null && this.t[this.conf.lastActive]) {
        this.t[this.conf.lastActive].conf.active = false;
        if (this.conf.contZone) {
            this.t[this.conf.lastActive].cell.cell.style.visibility = "hidden";
            this.t[this.conf.lastActive].cell.cell.style.top = "-5000px";
            this.t[this.conf.lastActive].cell.cell.style.zIndex = 0;
        }
        this.t[this.conf.lastActive].tab.className = this._tabCss(this.conf.lastActive);
        this.conf.lastActive = null;
    }
};
dhtmlXTabBar.prototype._isTabActive = function (a) {
    return a == this.conf.lastActive && this.conf.lastActive != null;
};
dhtmlXTabBar.prototype.getActiveTab = function () {
    return this.conf.lastActive;
};
dhtmlXTabBar.prototype.goToNextTab = function () {
    var a = this._getNextVisible(this.conf.lastActive, true);
    if (a != null) {
        this._setTabActive(a);
    }
};
dhtmlXTabBar.prototype.goToPrevTab = function () {
    var a = this._getPrevVisible(this.conf.lastActive, true);
    if (a != null) {
        this._setTabActive(a);
    }
};
dhtmlXTabBar.prototype._enableTab = function (c, a) {
    if (!this.t[c] || this.t[c].conf.enabled) {
        return;
    }
    this.t[c].conf.enabled = true;
    this.t[c].tab.className = this._tabCss(c);
    if (a == true) {
        this._setTabActive(c);
    }
};
dhtmlXTabBar.prototype._disableTab = function (c, a) {
    if (!this.t[c] || !this.t[c].conf.enabled) {
        return;
    }
    this.t[c].conf.enabled = false;
    this.t[c].tab.className = this._tabCss(c);
    if (a !== false && this.conf.lastActive == c) {
        if (a == true) {
            a = this._getNextVisible(c) || this._getPrevVisible(c);
        }
        this._setTabActive(a);
    }
};
dhtmlXTabBar.prototype._isTabEnabled = function (a) {
    return this.t[a] != null && this.t[a].conf.enabled == true;
};
dhtmlXTabBar.prototype._setTabText = function (g, e, c) {
    if (!this.t[g]) {
        return;
    }
    var a = false;
    if (typeof c == "undefined" || c == null) {
        c = this._getLabelWidth(e, this.t[g].conf.close);
        a = true;
    }
    this.t[g].tab.style.width = c + "px";
    this.t[g].tab.childNodes[0].innerHTML = e;
    this.t[g].conf.text = e;
    this.t[g].conf.width = c;
    this.t[g].conf.autowidth = a;
};
dhtmlXTabBar.prototype._getTabText = function (a) {
    if (!this.t[a]) {
        return null;
    }
    return this.t[a].conf.text;
};
dhtmlXTabBar.prototype._removeTab = function (n, e, l) {
    if (!this.t[n]) {
        return;
    }
    if (l != true && this.t[n].conf.remove != true) {
        this.t[n].conf.remove = true;
        this._hideTab(n, e);
        return;
    }
    if (typeof e == "undefined") {
        e = true;
    }
    var g = this._getNextVisible(n);
    var h = this._getPrevVisible(n);
    if (this.t[n].conf.transEv == true) {
        this.t[n].tab.removeEventListener(this.conf.transEv, this._doOnTrEnd, false);
        this.t[n].conf.transEv = false;
    }
    for (var c in this.t[n].conf) {
        this.t[n].conf[c] = null;
    }
    this.t[n].conf = null;
    delete this.t[n].conf;
    this.t[n].cell._unload();
    this.t[n].cell = null;
    this.t[n].tab.parentNode.removeChild(this.t[n].tab);
    this.t[n].tab = null;
    this.t[n] = null;
    delete this.t[n];
    this.conf.urls[n] = null;
    delete this.conf.urls[n];
    if (this.conf.lastActive == n) {
        this.conf.lastActive = null;
        if (e != false) {
            var m = e == true ? g || h || this._getFirstVisible() : e;
            if (m != null) {
                this._setTabActive(m);
            }
        }
    }
    else {
        if (l != true) {
            this._adjustTabs();
        }
    }
};
dhtmlXTabBar.prototype.clearAll = function () {
    for (var c in this.t) {
        this._removeTab(c, false, true);
    }
    this.tabsArea.childNodes[1].childNodes[0].style[this.conf.align] = "0px";
};
dhtmlXTabBar.prototype.moveTab = function (e, a) {
    if (!this.t[e] || a < 0) {
        return;
    }
    a += 1;
    var c = this.tabsArea.childNodes[1].firstChild;
    if (c.childNodes[a] != this.t[e].tab) {
        c.removeChild(this.t[e].tab);
        if (a >= c.childNodes.length) {
            c.appendChild(this.t[e].tab);
        }
        else {
            c.insertBefore(this.t[e].tab, c.childNodes[a]);
        }
    }
    c = null;
};
dhtmlXTabBar.prototype._getIndex = function (g) {
    var a = -1;
    var e = this.tabsArea.childNodes[1].firstChild;
    for (var c = 1; c < e.childNodes.length; c++) {
        if (e.childNodes[c]._tabId == g) {
            a = c - 1;
        }
    }
    e = null;
    return a;
};
dhtmlXTabBar.prototype.getNumberOfTabs = function (g) {
    var e = 0;
    for (var c in this.t) {
        e += g != true ? 1 : this.t[c].conf.visible == true ? 1 : 0;
    }
    return e;
};
dhtmlXTabBar.prototype.forEachCell = dhtmlXTabBar.prototype.forEachTab = function (e) {
    for (var c in this.t) {
        e.apply(window, [this.t[c].cell]);
    }
};
dhtmlXTabBar.prototype.enableAutoReSize = function () {
    this._initFSResize();
};
dhtmlXTabBar.prototype.setArrowsMode = function (a) {
    var jsonObj = { auto: "auto", always: "always" };
    a = jsonObj[String(a)];
    if (a == null || a == this.conf.mode) {
        return;
    }
    this.conf.arwMode = a;
    if (a == "always") {
        this.tabsArea.childNodes[0].className = "dhxtabbar_tabs_ar_left";
        this.tabsArea.childNodes[2].className = "dhxtabbar_tabs_ar_right";
    }
    this.setSizes();
};
dhtmlXTabBar.prototype._checkArrows = function () {
    var h = false;
    if (this.conf.arwMode == "auto") {
        var g = 0;
        for (var e in this.t) {
            g += this.t[e].tab.offsetWidth;
        }
        var c = this.tabsArea.childNodes[0];
        var l = this.tabsArea.childNodes[2];
        if (g > this.cont.offsetWidth) {
            if (c.className.search(/dhxtabbar_tabs_ar_hidden/) >= 0) {
                c.className = c.className.replace(/\s{0,}dhxtabbar_tabs_ar_hidden/, "");
                l.className = l.className.replace(/\s{0,}dhxtabbar_tabs_ar_hidden/, "");
                h = true;
            }
        }
        else {
            if (c.className.search(/dhxtabbar_tabs_ar_hidden/) < 1) {
                c.className += " dhxtabbar_tabs_ar_hidden";
                l.className += " dhxtabbar_tabs_ar_hidden";
                h = true;
            }
        }
        c = l = null;
    }
    return h;
};
dhtmlXTabBar.prototype._loadURLOnDemand = function (a) {
    if (a != null && this.conf.urls[a] != null) {
        this.cells(a).attachURL(this.conf.urls[a].href, this.conf.urls[a].ajax);
        this.conf.urls[a] = null;
    }
};

export default dhtmlXTabBar;



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/dhtmlXTabBar/dhtmlXTabBar.js